module.exports = __webpack_public_path__ + "static/three-best-rated-award-fae0908acfe88c8fc94bb26dcac98489.png";